import Vue from 'vue'
import request from '@/helpers/request'

export default {
  GET_EMPLOYER_CATEGORIES: ({ commit, state }, params) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.category}`,
      {
        params: params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setEmployerCategories', data.items)
      } else {
        // TODO: Show error dialog
      }
    })
  },
}
